import React from "react";
import ReactDOM from "react-dom";
import "./index.css";

//i18next for internationalization
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";

import { CookiesProvider } from "react-cookie";

import App from "./App";

import TagManager from "react-gtm-module";
import { googleTagManagerID } from "./utils/constants";

// configure google tag manager
const tagManagerArgs = {
    gtmId: googleTagManagerID,
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
    <I18nextProvider i18n={i18n}>
        <CookiesProvider>
            <App />
        </CookiesProvider>
    </I18nextProvider>,
    document.getElementById("root")
);
